import React from 'react';
import { Table, TableBody, TableHead } from '@mui/material';
import PropTypes from 'prop-types';
import summaryStyle, { BoxWrapper, MembersStyledTableCell, MembersStyledTableRow } from 'components/order-summary-details/style';

const MembersRequested = ({ membersDetails }) => {
    const validMembersDetails = Array.isArray(membersDetails) ? membersDetails : [];
    const hasSafeName = validMembersDetails.some((row) => row?.safeName);
    const hasRequestNumber = validMembersDetails.some((row) => row?.requestNumber);
    const hasSecondaryAccounts = validMembersDetails.some((row) => row?.secondaryAccountNames);
    return (
        <BoxWrapper>
            <Table sx={summaryStyle.financetable} aria-label="simple table">
                <TableHead>
                    <MembersStyledTableRow>
                        <MembersStyledTableCell scope="col" width="15%">
                            <b>GPID</b>
                        </MembersStyledTableCell>
                        <MembersStyledTableCell scope="col" width={`${!hasSafeName ? '25%' : '45%'}`}>
                            <b>Full Name</b>
                        </MembersStyledTableCell>
                        {!hasSafeName && (
                            <MembersStyledTableCell scope="col" width="35%">
                                <b>Email ID</b>
                            </MembersStyledTableCell>
                        )}
                        {hasRequestNumber && (
                            <MembersStyledTableCell scope="col" width="25%">
                                <b>Request Number</b>
                            </MembersStyledTableCell>
                        )}
                        {hasSafeName && (
                            <MembersStyledTableCell scope="col" width="25%">
                                <b>Safe Name</b>
                            </MembersStyledTableCell>
                        )}
                        {hasSecondaryAccounts && (
                            <MembersStyledTableCell scope="col" width="25%">
                                <b>Secondary Account</b>
                            </MembersStyledTableCell>
                        )}
                    </MembersStyledTableRow>
                </TableHead>
                <TableBody>
                    {validMembersDetails?.map((row, idx) => (
                        <MembersStyledTableRow key={`finacetable${idx}`}>
                            <MembersStyledTableCell scope="row" width="15%">
                                {row?.gpid}
                            </MembersStyledTableCell>
                            <MembersStyledTableCell scope="row" width={`${row?.email ? '25%' : '45%'}`}>
                                {row?.name}
                            </MembersStyledTableCell>
                            {!row?.safeName && (
                                <MembersStyledTableCell scope="row" width="35%" sx={{ wordBreak: 'break-all' }}>
                                    {row?.email === 'null' ? '' : row?.email}
                                </MembersStyledTableCell>
                            )}
                            {row?.requestNumber && (
                                <MembersStyledTableCell scope="row" width="25%">
                                    {row?.requestNumber === 'null' ? '' : row?.requestNumber}
                                </MembersStyledTableCell>
                            )}
                            {row?.safeName && (
                                <MembersStyledTableCell scope="row" width="25%">
                                    {row?.requestNumber === 'null' ? '' : row?.safeName}
                                </MembersStyledTableCell>
                            )}
                            {hasSecondaryAccounts && (
                                <MembersStyledTableCell scope="row" width="25%">
                                    {row?.secondaryAccountNames || '-'}
                                </MembersStyledTableCell>
                            )}
                        </MembersStyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </BoxWrapper>
    );
};

MembersRequested.propTypes = {
    membersDetails: PropTypes.array,
};

MembersRequested.defaultProps = {
    membersDetails: [],
};
export default React.memo(MembersRequested);
